import { render, staticRenderFns } from "./subdistricts.vue?vue&type=template&id=7a79bc8c&"
import script from "./subdistricts.vue?vue&type=script&lang=js&"
export * from "./subdistricts.vue?vue&type=script&lang=js&"
import style0 from "./subdistricts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports